import AnchorRouterPush from 'mixins/AnchorRouterPush';
import NewsletterAvailableCheck from 'mixins/NewsletterAvailableCheck';

const SocialShareLinkBuilder = {
  mixins: [NewsletterAvailableCheck, AnchorRouterPush],
  data() {
    return {
      sslbMixin_shareButtonsReady: false,
    };
  },
  mounted() {
    this.sslbMixin_shareButtonsReady = true;
  },
  computed: {
    sslbMixin_objectData() {
      return this.$store.getters.getActiveObjectData;
    },
    sslbMixin_eMailLink() {
      if (!this.sslbMixin_shareButtonsReady) return '';
      return `mailto:?subject=${this.$t('common:share.text', { clientname: this.clientname })} ${this.sslbMixin_objectData.title}&body=${this.$t('common:share.text', { clientname: this.clientname })} ${this.sslbMixin_objectData.title} (${this.sslbMixin_objectData.objectNumber})
      %0D%0A${this.sslbMixin_LinkBuilder('', 'email')}%0D%0A%0D%0A%0D%0A%0D%0A${this.voucherNotice}`;
    },
    sslbMixin_eMailLinkWatchlist() {
      if (!this.sslbMixin_shareButtonsReady) return '';
      return `mailto:?subject=${this.$t('user:watchList.share.intro', { clientname: this.clientname })}&body=${this.$t('user:watchList.share.intro', { clientname: this.clientname })}
      %0D%0A${this.sslbMixin_LinkBuilderWatchlist('', 'email')}%0D%0A%0D%0A%0D%0A%0D%0A${this.voucherNotice}`;
    },
    newsletterUrl() {
      const url = `${window.location.protocol}//${window.location.host}${this.arp_linkBuilder({ name: 'Newsletter' })}`;
      return url;
    },
    clientname() {
      if (this.$store.getters.getPartnerConfigValue('partnerName') !== '') return this.$store.getters.getPartnerConfigValue('partnerName').replace('&', 'und');
      return process.env.CLIENTNAME;
    },
    partnerID() {
      return this.$store.getters.getPartnerConfigValue('partnerID') || '';
    },
    voucherNotice() {
      if (this.nacMixin_newsletterAvailable) {
        return `${this.$t('common:newsletterVoucher.short')} ${this.newsletterUrl}`;
      }
      return '';
    },
  },
  methods: {
    // used to build the appropriated share link shareurl used to set url and type of medium to set medium of the utm tracking
    sslbMixin_LinkBuilder(shareUrl, typeofmedium) {
      const { objectNumber } = this.sslbMixin_objectData;
      const utmTrack = `utm_source=share${encodeURIComponent('&')}utm_medium=${typeofmedium}${encodeURIComponent('&')}utm_campaign=${objectNumber}`;
      const pageLink = this.$route.path;
      let url = '';
      if (!typeofmedium) {
        url = `${shareUrl}${window.location.protocol}//${window.location.host}${pageLink}`;
        if (this.partnerID !== '') url = `${url}?partner=${this.partnerID}`;
      } else {
        url = `${shareUrl}${window.location.protocol}//${window.location.host}${pageLink}?${utmTrack}`;
        if (this.partnerID !== '') url = `${url}${encodeURIComponent('&')}partner=${this.partnerID}`;
      }
      return url;
    },
    sslbMixin_LinkBuilderWatchlist(shareUrl, typeofmedium) {
      const pageLink = `${this.$route.path}?watchListUID%3D${this.$store.getters.getWatchListUID}`;
      const utmTrack = `%26utm_source%3Dshare%26utm_medium%3D${typeofmedium}%26utm_campaign%3DMerkzettel`;
      let url = '';
      if (!typeofmedium) {
        url = `${shareUrl}${window.location.protocol}//${window.location.host}${pageLink}`;
        if (this.partnerID !== '') url = `${url}?partner=${this.partnerID}`;
      } else {
        url = `${shareUrl}${window.location.protocol}//${window.location.host}${pageLink}${utmTrack}`;
        if (this.partnerID !== '') url = `${url}%26partner=${this.partnerID}`;
      }
      return url;
    },
  },
};

export default SocialShareLinkBuilder;
